import script from "./PeopleTagsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleTagsModal.vue?vue&type=script&setup=true&lang=js"

import "./PeopleTagsModal.vue?vue&type=style&index=0&id=925d8748&lang=css"

const __exports__ = script;

export default __exports__